import wx from "weixin-js-sdk";
import api from "networks/api/api.js";
import CONFIG from '@/config'

// 分享给朋友
export const shareWithFriend = ({ title, desc, link, imgUrl }) => {
  wx.ready(function () {
    //需在用户可能点击分享按钮前就先调用
    wx.onMenuShareAppMessage({
      title,
      desc,
      link,
      imgUrl,
      success: () => {
        console.log("success-----");
      },
    });
  });
};

// 分享到朋友圈
export const shareWithTimeLine = ({ title, desc, link, imgUrl }) => {
  wx.ready(function () {
    //需在用户可能点击分享按钮前就先调用
    wx.onMenuShareTimeline({
      title,
      desc,
      link,
      imgUrl,
      success: () => {
        console.log("success-----");
      },
    });
  });
};

export const wxShare = (data) => {
  // 兼容之前的代码特殊处理path
  const shareData = {
    link: data?.path ? `${window.location.origin}/#/${data.path}`: window.location.href,
    title: data?.title ? '阿牛数据-' + data.title : "阿牛数据",
    desc: data?.desc || "",
    imgUrl: data?.imgUrl || "https://static.aniudata.com/logo.png",
  }
  console.log('sharein=======', shareData)
  shareWithFriend(shareData);
  shareWithTimeLine(shareData);
};

export const init = async () => {
  const { nonceStr, signature, timeStamp } = await api.getJsTicket({
    jsApiUrl: location.href.split("#")[0],
  });
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: `${CONFIG.appid}`, // 必填，公众号的唯一标识
    timestamp: timeStamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名
    jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
  });
};
